import ExportAdaptiveQuizReportData from './ExportAdaptiveQuizReportData';

export default ExportAdaptiveQuizReportData;
